<script setup lang="ts">
// @ts-ignore
import QRCode from 'qrcode';

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { TimeClock } from '../../interfaces/time-clock.interface';
const { t } = useI18n();

// #region props & emits
const props = defineProps<{
   timeClock: TimeClock;
}>();
// #endregion

// #region qr
const time_clock = ref();
onMounted(async () => {
   if (!props.timeClock?.time_clock_token?.uuid_url) return;
   time_clock.value = await QRCode.toDataURL(props.timeClock.time_clock_token.uuid_url);
});
// #endregion

// #region open url
function openUrl(url?: string) {
   if (!url) return;
   window.open(url, '_blank');
}
// #endregion
</script>

<template>
   <div class="detail">
      <div class="detail__code">
         <img v-if="time_clock" :src="time_clock" alt="QR-code" />
      </div>
      <div class="detail__info">
         <span class="title">{{ timeClock.name }}</span>
         <span class="button" @click="openUrl(timeClock?.time_clock_token?.uuid_url)">
            <i class="fa-solid fa-arrow-up-right-from-square" />
            {{ t('go_to_qr') }}
         </span>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.detail {
   z-index: 1;

   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;

   width: calc(100% - var(--nxt-gutter-large) * 2);
   height: calc(100% - var(--nxt-gutter-large));

   padding: 0 calc(var(--nxt-gutter-large) * 2);
}

.title {
   color: white;
   font-size: 3.5rem;
   text-align: center;
   font-weight: 500;
   text-align: left;
}

.detail__code {
   display: flex;
   justify-content: center;
   align-items: center;
   flex: 1;
   height: 400px;

   img {
      height: 100%;
   }
}

.detail__info {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   flex: 1;
   gap: var(--nxt-gutter);
}

.button {
   display: flex;
   justify-content: center;
   align-items: center;
   gap: var(--nxt-gutter);

   padding: var(--nxt-gutter) var(--nxt-gutter-large);

   color: var(--nxt-white);
   background-color: var(--nxt-plan-main);
   border-radius: var(--nxt-radius);
   font-size: var(--nxt-font-large);

   &:hover {
      cursor: pointer;
      background-color: var(--nxt-plan-main-hover);
   }
}
</style>
